ControleValidator.$inject = ['validator'];

export default function ControleValidator(validator) {
    const instance = new validator();

    return instance;
}
